import {
    DetailsListLayoutMode,
    IColumn, SelectionMode, Stack, Toggle
} from "@fluentui/react";
import { RootState } from "app/store";
import React, { useMemo, useState } from "react";
import { connect, ConnectedProps, useDispatch } from "react-redux";
import { changeMergeSnap } from "../../global/Reducer/compSlice";
import {
    ICESNumber as FAM_ICESNumber,
    IDepartment as FAM_IDepartment,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "../../model/FlexibleAttributeModel";

import { StickyDetailsList } from "../../components/layout/StickyDetailList";


interface IProps extends TComponentConnectedProps {
    snap?: FAM_IGroupConfigurationData;
    snap2?: FAM_IGroupConfigurationData;
    mergeSnap?: FAM_IGroupConfigurationData;
    compare?: boolean;
    disabled?: boolean;
    merge?: boolean;
    leftright: boolean;
    counter: number
    noDiff: () => void;
}


interface IGridItem {
    key: string;
    cesNumber: string | null;
    departmentName: JSX.Element | null;
    departmentDescription: JSX.Element | null;
    data: FAM_IDepartment | null;
    merge?: JSX.Element;
}

const GroupStructureDepartmentView = (props: IProps) => {

    const snap = props.snap || props.state.data.json;

    const [counter, setCounter] = useState<number>(0);
    const [leftRight, setLeftRight] = useState<Record<string, boolean>>({"default": props.leftright!})
   const dispatch = useDispatch();
    React.useEffect(() => {
        setLeftRight({"default": props.leftright!});
        setCounter(props.counter+1);
    }, [props.leftright, props.counter]);

    const items = useMemo(() => {
        const items: IGridItem[] = [];
        const items2: IGridItem[] = [];
        const mergeItems: IGridItem[] = [];

        const highlightStyles = {backgroundColor: 'yellow'};


       snap?.groupStructure?.cesNumbers.forEach(eaCesNumber => {
            snap.groupStructure?.departments.forEach(eachDepartment => {
                // lets skip departments that are not for current group number.
                if (eachDepartment.cesNumberRef?.id !== eaCesNumber.id)
                    return;
                let change = false;
                const compareDepartment = props.snap2?.groupStructure?.departments?.filter(d => !d.deactivated).find((d: FAM_IDepartment) => d.name === eachDepartment.name) ?? props.snap2?.groupStructure?.departments?.filter(d => !d.deactivated).find((d: FAM_IDepartment) => d.id === eachDepartment.id)
                const mergeDepartment = props.mergeSnap?.groupStructure?.departments?.filter(d => !d.deactivated).find((d: FAM_IDepartment) => d.name === eachDepartment.name) ?? props.mergeSnap?.groupStructure?.departments?.filter(d => !d.deactivated).find((d: FAM_IDepartment) => d.id === eachDepartment.id)

                if(JSON.stringify(eachDepartment) === JSON.stringify(compareDepartment)) {
                    if (!props.state.status.displayAll)
                        return
                }
                else{
                    change = true;
                }

                items.push({
                    key: eachDepartment.id,
                    cesNumber: eachDepartment.cesNumberRef?.name!,
                    departmentName: change ? <span style={highlightStyles}>{eachDepartment.name}</span> :<span>{eachDepartment.name}</span> ,
                    departmentDescription: change ? <span style={highlightStyles}>{eachDepartment.description}</span> : <span>{eachDepartment.description}</span>,
                    data: eachDepartment
                });
                if(compareDepartment){
                    items2.push({
                        key: compareDepartment.id,
                        cesNumber: compareDepartment.cesNumberRef?.name!,
                        departmentName: change ? <span style={highlightStyles}>{compareDepartment.name}</span> :<span>{compareDepartment.name}</span> ,
                        departmentDescription: change ? <span style={highlightStyles}>{compareDepartment.description}</span> : <span>{compareDepartment.description}</span>,
                        data: compareDepartment
                    });
                }
                else{
                    items2.push({
                        key: eachDepartment.id,
                        cesNumber: null,
                        departmentDescription: null,
                        departmentName: null,
                        data: null
                    });
                }
                const toggle = !change ? (<span>No Changes</span>) :
                    (<Toggle onText="Right" offText="Left"
                             key={`${eachDepartment.id}`}
                             onChange={(event, checked) => {
                                 setCounter(counter + 1);
                                 setLeftRight((prevState) => {
                                     if (prevState[eachDepartment.id] !== undefined && prevState[eachDepartment.id] !== null)
                                         return {
                                             ...prevState,
                                             [eachDepartment.id]: !prevState[eachDepartment.id]
                                         }
                                     return {...prevState, [eachDepartment.id]: !props.leftright}
                                 })
                                 const fieldIndex = props.state.comp.mergeSnap.json?.groupStructure.departments?.filter(d => !d.deactivated).findIndex(q => eachDepartment.id === q.id) ?? -1;
                                 const cesIndex = props.state.comp.mergeSnap.json?.groupStructure.cesNumbers?.findIndex(q => eaCesNumber.id === q.id) ?? -1;
                                 if (checked) {
                                     if (compareDepartment)
                                         dispatch(changeMergeSnap({
                                             ...props.state.comp.mergeSnap, json: {
                                                 ...props.state.comp.mergeSnap.json,
                                                 groupStructure: {
                                                     ...props.state.comp.mergeSnap.json?.groupStructure,
                                                     departments: [...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(0, fieldIndex), compareDepartment, ...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(fieldIndex + 1)],
                                                     cesNumbers: [...props.state.comp.mergeSnap.json?.groupStructure?.cesNumbers?.slice(0, cesIndex), eaCesNumber, props.state.comp.mergeSnap.json?.groupStructure?.cesNumbers?.slice(cesIndex + 1)]
                                                 }
                                             }
                                         }));
                                     else
                                         dispatch(changeMergeSnap({
                                             ...props.state.comp.mergeSnap, json: {
                                                 ...props.state.comp.mergeSnap.json,
                                                 groupStructure: {
                                                     ...props.state.comp.mergeSnap.json?.groupStructure,
                                                     departments: [...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(0, fieldIndex), ...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(fieldIndex + 1)],
                                                 }
                                             }
                                         }));
                                 }
                                 else {
                                     dispatch(changeMergeSnap({
                                         ...props.state.comp.mergeSnap, json: {
                                             ...props.state.comp.mergeSnap.json,
                                             groupStructure: {
                                                 ...props.state.comp.mergeSnap.json?.groupStructure,
                                                 departments: [...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(0, fieldIndex), eachDepartment, ...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(fieldIndex + 1)],
                                                 cesNumbers: [...props.state.comp.mergeSnap.json?.groupStructure?.cesNumbers?.slice(0,cesIndex), eaCesNumber, props.state.comp.mergeSnap.json?.groupStructure?.cesNumbers?.slice(cesIndex +1)]
                                             }
                                         }
                                     }));
                                 }
                             } } checked={leftRight[eachDepartment.id] !== undefined ? leftRight[eachDepartment.id]! : props.leftright}
                             style={{}} onClick={(event) => {
                        if (event?.stopPropagation) event.stopPropagation();
                    }}
                    />);
                if(mergeDepartment){
                    mergeItems.push({
                    key: mergeDepartment.id,
                    cesNumber: mergeDepartment.cesNumberRef?.name!,
                    departmentName: <span>{mergeDepartment.name}</span>,
                    departmentDescription:<span>{mergeDepartment.description}</span>,
                    data: mergeDepartment, merge: toggle
                });
                }
                else{
                    mergeItems.push({
                        key: eachDepartment.id,
                        cesNumber: null,
                        departmentDescription: null,
                        departmentName: null,
                        data: null, merge: toggle
                    });
                }
            });

            props.snap2?.groupStructure?.departments?.filter(d => !d.deactivated).filter(eDepartment =>
                snap.groupStructure?.departments?.filter(d => !d.deactivated).findIndex((d: FAM_IDepartment) =>
                    eDepartment.name === d.name || eDepartment.id === d.id) === -1).forEach(eachDepartment => {
                if (eachDepartment.cesNumberRef?.id === eaCesNumber.id) {
                    items2.push({
                        key: eachDepartment.id,
                        cesNumber: eachDepartment.cesNumberRef?.name!,
                        departmentName: <span style={highlightStyles}>{eachDepartment.name}</span>,
                        departmentDescription: <span style={highlightStyles}>{eachDepartment.description}</span>,
                        data: eachDepartment
                    });
                    items.push({
                        key: eachDepartment.id,
                        cesNumber: null,
                        departmentDescription: null,
                        departmentName: null,
                        data: null
                    });
                    const mergeDepartment = props.mergeSnap?.groupStructure?.departments?.filter(d => !d.deactivated).find((d: FAM_IDepartment) => d.name === eachDepartment.name) ?? props.mergeSnap?.groupStructure?.departments?.filter(d => !d.deactivated).find((d: FAM_IDepartment) => d.id === eachDepartment.id)
                    const toggle =
                        (<Toggle onText="Right" offText="Left"
                                 key={`${eachDepartment.id}`}
                                 onChange={(event, checked) => {
                                     setCounter(counter + 1);
                                     setLeftRight((prevState) => {
                                         if (prevState[eachDepartment.id] !== undefined && prevState[eachDepartment.id] !== null)
                                             return {
                                                 ...prevState,
                                                 [eachDepartment.id]: !prevState[eachDepartment.id]
                                             }
                                         return {...prevState, [eachDepartment.id]: !props.leftright}
                                     })
                                     const fieldIndex = props.state.comp.mergeSnap.json?.groupStructure.departments?.filter(d => !d.deactivated).findIndex(q => eachDepartment.id === q.id) ?? -1;
                                     const cesIndex = props.state.comp.mergeSnap.json?.groupStructure.cesNumbers?.findIndex(q => eaCesNumber.id === q.id) ?? -1;
                                     if (checked) {
                                         dispatch(changeMergeSnap({
                                             ...props.state.comp.mergeSnap, json: {
                                                 ...props.state.comp.mergeSnap.json,
                                                 groupStructure: {
                                                     ...props.state.comp.mergeSnap.json?.groupStructure,
                                                     departments: [...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(0, fieldIndex), eachDepartment, ...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(fieldIndex + 1)],
                                                     cesNumbers: [...props.state.comp.mergeSnap.json?.groupStructure?.cesNumbers?.slice(0, cesIndex), eaCesNumber, props.state.comp.mergeSnap.json?.groupStructure?.cesNumbers?.slice(cesIndex + 1)]
                                                 }
                                             }
                                         }));
                                     } else {
                                         dispatch(changeMergeSnap({
                                             ...props.state.comp.mergeSnap, json: {
                                                 ...props.state.comp.mergeSnap.json,
                                                 groupStructure: {
                                                     ...props.state.comp.mergeSnap.json?.groupStructure,
                                                     departments: [...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(0, fieldIndex), ...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(fieldIndex + 1)],
                                                 }
                                             }
                                         }));
                                     }
                                 }}
                                 checked={leftRight[eachDepartment.id] !== undefined ? leftRight[eachDepartment.id]! : props.leftright}
                                 style={{}} onClick={(event) => {
                            if (event?.stopPropagation) event.stopPropagation();
                        }}
                        />);
                    if (mergeDepartment) {
                        mergeItems.push({
                            key: mergeDepartment.id,
                            cesNumber: mergeDepartment.cesNumberRef?.name!,
                            departmentName: <span>{mergeDepartment.name}</span>,
                            departmentDescription: <span>{mergeDepartment.description}</span>,
                            data: mergeDepartment,
                            merge: toggle
                        });
                    } else {
                        mergeItems.push({
                            key: eachDepartment.id,
                            cesNumber: null,
                            departmentDescription: null,
                            departmentName: null,
                            data: null, merge: toggle
                        });
                    }
                }
            })
        });

       props.snap2?.groupStructure.cesNumbers.filter(eaCesNumber =>
           snap?.groupStructure?.cesNumbers?.findIndex((d:FAM_ICESNumber) => eaCesNumber.id === d.id) === -1).forEach(eaCesNumber => {
               props.snap2?.groupStructure?.departments?.filter(d => !d.deactivated).forEach(eachDepartment => {
           if (eachDepartment.cesNumberRef?.id !== eaCesNumber.id)
               return;
                 items2.push({
                   key: eachDepartment.id,
                   cesNumber: eachDepartment.cesNumberRef?.name!,
                   departmentName:<span style={highlightStyles}>{eachDepartment.name}</span>,
                   departmentDescription: <span style={highlightStyles}>{eachDepartment.description}</span>,
                   data: eachDepartment
               });
               items.push({
                   key: eachDepartment.id,
                   cesNumber: null,
                   departmentDescription: null,
                   departmentName: null,
                   data: null
               });
               const mergeDepartment = props.mergeSnap?.groupStructure?.departments?.filter(d => !d.deactivated).find((d: FAM_IDepartment) => d.name === eachDepartment.name) ?? props.mergeSnap?.groupStructure?.departments?.filter(d => !d.deactivated).find((d: FAM_IDepartment) => d.id === eachDepartment.id)
                   const toggle =
                       (<Toggle onText="Right" offText="Left"
                               key={`${eachDepartment.id}`}
                               onChange={(event, checked) => {
                                   setCounter(counter + 1);
                                   setLeftRight((prevState) => {
                                       if (prevState[eachDepartment.id] !== undefined && prevState[eachDepartment.id] !== null)
                                           return {
                                               ...prevState,
                                               [eachDepartment.id]: !prevState[eachDepartment.id]
                                           }
                                       return {...prevState, [eachDepartment.id]: !props.leftright}
                                   })
                                       const fieldIndex = props.state.comp.mergeSnap.json?.groupStructure.departments?.filter(d => !d.deactivated).findIndex(q => eachDepartment.id === q.id) ?? -1;
                                       const cesIndex = props.state.comp.mergeSnap.json?.groupStructure.cesNumbers?.findIndex(q => eaCesNumber.id === q.id) ?? -1;
                                       if (checked) {
                                               dispatch(changeMergeSnap({
                                                   ...props.state.comp.mergeSnap, json: {
                                                       ...props.state.comp.mergeSnap.json,
                                                       groupStructure: {
                                                           ...props.state.comp.mergeSnap.json?.groupStructure,
                                                           departments: [...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(0, fieldIndex), eachDepartment, ...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(fieldIndex + 1)],
                                                           cesNumbers: [...props.state.comp.mergeSnap.json?.groupStructure?.cesNumbers?.slice(0,cesIndex), eaCesNumber, props.state.comp.mergeSnap.json?.groupStructure?.cesNumbers?.slice(cesIndex +1)]
                                                       }
                                                   }
                                               }));
                                       } else {
                                           dispatch(changeMergeSnap({
                                               ...props.state.comp.mergeSnap, json: {
                                                   ...props.state.comp.mergeSnap.json,
                                                   groupStructure: {
                                                       ...props.state.comp.mergeSnap.json?.groupStructure,
                                                       departments: [...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(0, fieldIndex), ...props.state.comp.mergeSnap.json?.groupStructure?.departments?.filter(d => !d.deactivated).slice(fieldIndex + 1)],
                                                   }
                                               }
                                           }));
                                       }
                               } } checked={leftRight[eachDepartment.id] !== undefined ? leftRight[eachDepartment.id]! : props.leftright}
                                   style={{}} onClick={(event) => {
                                   if (event?.stopPropagation) event.stopPropagation();
                               }}
                                   />);
               if(mergeDepartment) {
                   mergeItems.push({
                       key: mergeDepartment.id,
                       cesNumber: mergeDepartment.cesNumberRef?.name!,
                       departmentName: <span>{mergeDepartment.name}</span>,
                       departmentDescription: <span>{mergeDepartment.description}</span>,
                       data: mergeDepartment,
                       merge: toggle
                   });
               }
               else{
                   mergeItems.push({
                       key: eachDepartment.id,
                       cesNumber: null,
                       departmentDescription: null,
                       departmentName: null,
                       data: null,
                       merge: toggle
                   });
               }

           })

       })




        return {items, mergeItems, items2};
    }, [snap?.groupStructure?.groupNumbers, snap?.groupStructure?.departments, props.snap2, props.mergeSnap, props.compare, props.state.status.displayAll]);

    const columns = useMemo(() => {
        const columns: IColumn[] = [
            { key: 'cesClientNumber', name: 'CES Client Number', fieldName: 'cesNumber', minWidth: 120, maxWidth: 140, isResizable: true },
            { key: 'department', name: 'Department', fieldName: 'departmentName', minWidth: 100, maxWidth: 120, isResizable: true },
            { key: 'departmentDescription', name: 'Description', fieldName: 'departmentDescription', minWidth: 100, maxWidth: 100, isResizable: true },
        ]
        return columns;
    }, []);


    const gridStyles = {
        root: {
            marginBottom: '1.45em'
        },
        headerWrapper: {
            selectors: {
                '.ms-DetailsHeader': {
                    paddingTop: '0px',
                },
            }
        }
    };

    const width = props.merge ? '30%' : '48%';

    if(items.items?.length > 0) {
        return (


            <Stack horizontal disableShrink horizontalAlign="space-evenly" style={{maxWidth: '100%'}}>
                <Stack.Item grow style={{maxWidth: width}}>

                    <StickyDetailsList
                        items={items.items}
                        columns={columns}
                        styles={gridStyles}
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        compact={true}

                        selectionMode={SelectionMode.none}
                    />

                </Stack.Item>
                <Stack.Item grow style={{maxWidth: width}}>
                    <StickyDetailsList
                        items={items.items2}
                        columns={columns}
                        styles={gridStyles}
                        layoutMode={DetailsListLayoutMode.fixedColumns}
                        compact={true}

                        selectionMode={SelectionMode.none}
                    />

                </Stack.Item>
                {props.merge &&
                    <Stack.Item grow style={{maxWidth: width}} className={`${counter}merge`}>
                        <StickyDetailsList
                            items={items.mergeItems}
                            columns={[{
                                key: 'mergetoggle',
                                name: 'Merge',
                                minWidth: 100,
                                fieldName: 'merge',
                                maxWidth: 150,
                                isResizable: false
                            },
                                ...columns]}
                            styles={gridStyles}
                            layoutMode={DetailsListLayoutMode.fixedColumns}
                            compact={true}

                            selectionMode={SelectionMode.none}
                        />
                    </Stack.Item>
                }
            </Stack>
        )
    }
    else {
        props.noDiff();
        return null
    }
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(GroupStructureDepartmentView);

